import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { STOCK_COUNT, StockCountStatusValues, StockCountTypeValues, STOCK_COUNT_TYPE_LABELS, STOCK_COUNT_STATUS_LABELS, } from '../types/stock-count.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for StockCount (0116) — read via `/pg/v1`.
 * Mutated only by `/stock/counts*` (freeze + close/adjust live in the ledger).
 */
export const stockCountDescriptor = {
    name: STOCK_COUNT,
    label: 'Contagem de estoque',
    domain: 'stock',
    collectionPath: 'org/{orgId}/stock-count',
    pathPatternKeys: { orgId: 'string' },
    version: 1,
    description: 'Inventory / cycle count header with scope freeze (0116)',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    writePolicy: 'readonly',
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        {
            name: 'countNumber',
            label: 'Número',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.CODE,
        },
        {
            name: 'type',
            label: 'Tipo',
            type: 'enum',
            required: true,
            enumValues: [...StockCountTypeValues],
            enumLabels: STOCK_COUNT_TYPE_LABELS,
        },
        { name: 'distributionCenterId', label: 'CD', type: 'string', required: false },
        { name: 'stockLocationId', label: 'Local', type: 'string', required: false },
        { name: 'storageAddressId', label: 'Endereço', type: 'string', required: false },
        { name: 'productId', label: 'Produto', type: 'string', required: false },
        {
            name: 'status',
            label: 'Status',
            type: 'enum',
            required: true,
            enumValues: [...StockCountStatusValues],
            enumLabels: STOCK_COUNT_STATUS_LABELS,
        },
        { name: 'frozenAt', label: 'Congelado em', type: 'date', required: false },
        { name: 'freezeExpiresAt', label: 'Expira em', type: 'date', required: false },
        { name: 'closedAt', label: 'Fechado em', type: 'date', required: false },
        { name: 'createdBy', label: 'Criado por', type: 'string', required: false },
        { name: 'createdAt', label: 'Criado em', type: 'date', required: false },
    ],
    foreignKeys: [
        {
            fieldName: 'distributionCenterId',
            targetEntity: 'DistributionCenter',
            relationship: 'many-to-one',
            displayField: 'name',
        },
        {
            fieldName: 'stockLocationId',
            targetEntity: 'StockLocation',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'storageAddressId',
            targetEntity: 'StorageAddress',
            relationship: 'many-to-one',
            displayField: 'code',
        },
        {
            fieldName: 'productId',
            targetEntity: 'Product',
            relationship: 'many-to-one',
            displayField: 'description',
        },
    ],
};
//# sourceMappingURL=stock-count.descriptor.js.map